import { render, staticRenderFns } from "./ProductsMemberships.vue?vue&type=template&id=7bbf2df1&scoped=true"
import script from "./ProductsMemberships.vue?vue&type=script&lang=js"
export * from "./ProductsMemberships.vue?vue&type=script&lang=js"
import style0 from "./ProductsMemberships.vue?vue&type=style&index=0&id=7bbf2df1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbf2df1",
  null
  
)

export default component.exports